import React, { useState, useEffect, useContext } from "react";
import AddCircleForm from "./AddCircleForm";
import EditCircleForm from "./EditCircleForm";
import axios from "axios";
import { toast } from "react-toastify";
import { AuthContext } from "../../Context/AuthContext";
import { logActivity } from "../../utils/LogActivity";
import Preloader from "../../shared/PreLoaders";
import { Authorization } from "../../Context/Authorization";

const thStyle = { padding: "10px 12px", fontSize: 12, fontWeight: 700, color: "#2D3748", background: "#F7FAFC", border: "1px solid #E2E8F0", textAlign: "left" };
const tdStyle = { padding: "9px 12px", fontSize: 12, color: "#4A5568", border: "1px solid #E2E8F0" };

const Circle = () => {
  const [circle, setCircle] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [currentCircle, setCurrentCircle] = useState(null);
  const { permissions, userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const Api = process.env.REACT_APP_API;

  useEffect(() => {
    const fetchCircle = async () => {
      try {
        const config = Authorization();
        const response = await axios.get(`${Api}/api/circles`, config);
        setCircle(response.data);
      } catch (err) {
        console.error("Error fetching data", err);
      }
      setLoading(false);
    };
    fetchCircle();
  }, [Api]);

  const handleDeleteState = async (id) => {
    if (!window.confirm("Are you sure you want to delete this circle?")) return;
    try {
      const config = Authorization();
      await axios.delete(`${Api}/api/circles/${id}`, config);
      setCircle(circle.filter((c) => c._id !== id));
      toast.success("Deleted Successfully");
      await logActivity(userId, "Deleted Circle", "Circle Page", Api);
    } catch (err) {
      console.error("Error deleting Circle", err);
      toast.error("Failed to delete the circle.");
    }
  };

  const handleAddCircle = (newCircle) => setCircle([...circle, newCircle]);

  return (
    <div>
      {loading && <Preloader loading={loading} />}

      {/* ── Page Header ── */}
      <div style={{ marginBottom: 20 }}>
        <h4 style={{ margin: 0, fontWeight: 700, color: "#1A202C", fontSize: 18 }}>Circle</h4>
        <div style={{ fontSize: 12, color: "#718096", marginTop: 3 }}>
          <span style={{ color: "#A0AEC0" }}>VFC</span>
          <span style={{ margin: "0 6px", color: "#CBD5E0" }}>›</span>
          <span style={{ color: "#2E7D32", fontWeight: 600 }}>Circle</span>
        </div>
      </div>

      {/* ── Table Card ── */}
      <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", boxShadow: "0 1px 4px rgba(0,0,0,0.07)", overflow: "hidden" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 16px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)" }}>
          <span style={{ width: 30, height: 30, background: "rgba(255,255,255,0.15)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 15 }}>
            <i className="mdi mdi-circle-outline" />
          </span>
          <span style={{ fontSize: 13, fontWeight: 700, color: "#fff", flex: 1 }}>Circle List</span>
          <span style={{ padding: "3px 10px", background: "rgba(255,255,255,0.2)", borderRadius: 20, fontSize: 11, color: "#fff", fontWeight: 600 }}>
            {circle.length} Records
          </span>
          {permissions.includes("AddCircle") && (
            <button onClick={() => setShowPopup(true)}
              style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "7px 14px", background: "rgba(255,255,255,0.2)", color: "#fff", border: "1px solid rgba(255,255,255,0.4)", borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
              <i className="mdi mdi-plus" /> Create New
            </button>
          )}
        </div>

        <div style={{ padding: 16, overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={thStyle}>#</th>
                <th style={thStyle}>Circle Name</th>
                <th style={thStyle}>Circle Code</th>
                {permissions.includes("EditCircle") && permissions.includes("DeleteCircle") && (
                  <th style={thStyle}>Actions</th>
                )}
              </tr>
            </thead>
            <tbody>
              {circle.length === 0 ? (
                <tr>
                  <td colSpan={4} style={{ ...tdStyle, textAlign: "center", color: "#A0AEC0", padding: "40px" }}>No circle records found.</td>
                </tr>
              ) : (
                circle.map((item, index) => (
                  <tr key={item._id} style={{ background: index % 2 === 0 ? "#fff" : "#F7FAFC" }}>
                    <td style={tdStyle}>{index + 1}</td>
                    <td style={{ ...tdStyle, fontWeight: 600, color: "#2D3748" }}>{item.circleName}</td>
                    <td style={tdStyle}>{item.circleCode}</td>
                    {permissions.includes("EditCircle") && permissions.includes("DeleteCircle") && (
                      <td style={tdStyle}>
                        <i className="mdi mdi-pen" style={{ fontSize: "1.4rem", cursor: "pointer", marginRight: 8, color: "#2E7D32" }}
                          onClick={() => { setCurrentCircle(item); setShowEditPopup(true); }} />
                        <i className="mdi mdi-delete" style={{ fontSize: "1.4rem", cursor: "pointer", color: "#E53E3E" }}
                          onClick={() => handleDeleteState(item._id)} />
                      </td>
                    )}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {showPopup && <AddCircleForm onClose={() => setShowPopup(false)} onAddCircle={handleAddCircle} />}
      {showEditPopup && currentCircle && <EditCircleForm circle={currentCircle} onClose={() => { setShowEditPopup(false); setCurrentCircle(null); }} />}
    </div>
  );
};

export default Circle;
